<template>
    <div>
        <template v-if="atendimento && canal">
            <div class="d-flex justify-content-between">
                <div>
                    <a href="#" @click.prevent="reabrir()" class="card-link" v-if="dados">
                        Reabrir
                    </a>
                </div>
                <div class="small text-muted">
                    {{ canal }}
                </div>
            </div>
        
            <div class="mb-3 border py-3 alert-success" v-if="atendimento && canal">
                <div class="container-fluid chat_container">
                    <!--
                    <daai-component 
                        apiKey="e263bb8c-ce1f-4fc4-9114-e8d3fb562093" 
                        modeApi="dev" 
                        ref="daai"
                        :metadata="JSON.stringify({ name: 'doctor', role: 'Assistant', id: atendimento.id_atendimento, cn: canal })"></daai-component>
                    -->
                    <daai-consultation-recorder
                        v-if="is_teste"
                        apiKey="e263bb8c-ce1f-4fc4-9114-e8d3fb562093" 
                        modeApi="dev" 
                        ref="daai"
                        :metadata="JSON.stringify({ name: 'doctor', role: 'Assistant', id: atendimento.id_atendimento, dm: dominio, cn: canal })"
                        professional="1234"></daai-consultation-recorder>

                    <daai-consultation-recorder
                        v-else
                        apiKey="PRODUCTION-6c47a264-e7bf-43f4-9df2-3fdf6651dcbd" 
                        ref="daai"
                        :metadata="JSON.stringify({ name: 'doctor', role: 'Assistant', id: atendimento.id_atendimento, dm: dominio, cn: canal })"
                        :professional="profissional"></daai-consultation-recorder>
                </div>
            </div>
        </template> 

        <!-- DAAI Modal -->
        <div class="modal fade" id="daaiModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Resultado {{ ident }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-loading v-if="!dados" msg="Aguarde..." />

                        <template v-else>

                            <div class="card" v-if="dados.transcricao">
                                <div class="card-header">
                                    <a class="card-link" data-toggle="collapse" href="#collapseTranscricao">
                                        Transcrição
                                    </a>
                                </div>
                                <div class="collapse" id="collapseTranscricao">
                                    <div class="card-body">
                                        <div style="white-space: pre-wrap;">{{ dados.transcricao }}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="col col-12">
                                    <az-input
                                        type="button-group"
                                        sizing="sm"
                                        :optionsList="[
                                            { id: 'GF', search: 'Gerar Formulário' },
                                            { id: 'PF', search: 'Preencher Formulário' },
                                            { id: 'CR', search: 'Copiar Texto' },
                                            { id: 'CT', search: 'Copiar Transcrição' },
                                        ]"
                                        optionsData="id"
                                        optionsDisplay="search"
                                        v-model="acao" />
                                </div>
                            </div>

                            <div class="alert alert-info small py-2" v-if="acao">
                                <span v-if="acao == 'GF'">Clique em "Atualizar" para gerar o formulário, com os campos identificados pela IA.</span>
                                <span v-if="acao == 'PF'">Clique em "Atualizar" para preencher o formulário, com os campos identificados pela IA.</span>
                                <span v-if="acao == 'CR'">Clique em "Atualizar" para copiar o texto gerado pela IA para área de transferência.</span>
                                <span v-if="acao == 'CT'">Clique em "Atualizar" para copiar o texto da transcrição para área de transferência.</span>
                            </div>

                            <table class="table">
                                <template v-for="(dado, idx) in dados.campos">
                                    <tr :key="idx" v-if="dado">
                                        <td width="20%">
                                            {{ dado.title }}
                                            <div class="small text-muted">{{ dado.id }}</div>
                                        </td>
                                        <td>
                                            <az-input 
                                                type="textarea"
                                                sizing="sm"
                                                v-model="dado.value" 
                                                v-if="dado.edit" />

                                            <div style="white-space: pre-wrap;" v-else>{{ dado.value }}</div>
                                        </td>
                                        <td width="5%" class="text-nowrap">
                                            <button type="button" class="btn btn-sm btn-outline-primary ml-1" @click="dado.edit = !dado.edit">
                                                <i class="fa-solid fa-pen-to-square"></i>
                                            </button>

                                            <button type="button" class="btn btn-sm btn-outline-primary ml-1" @click="copiar_texto(dado.value, dado.title)">
                                                <i class="fa-solid fa-copy"></i>
                                            </button>
                                        </td>
                                        <td v-if="acao == 'PF'">
                                            <az-input
                                                placeholder="Selecione..."
                                                type="select"
                                                sizing="sm"
                                                :optionsList="campos_atuais"
                                                optionsData="id"
                                                optionsDisplay="label"
                                                v-model="dado.kid" />
                                        </td>
                                    </tr>
                                </template>
                            </table>

                            <div class="card">
                                <div class="card-header">
                                    <a class="card-link" data-toggle="collapse" href="#collapseDebug">
                                        Depuração
                                    </a>
                                </div>
                                <div class="collapse" id="collapseDebug">
                                    <div class="card-body">
                                        <pre>{{ retorno }}</pre>
                                        <hr>
                                        <pre>{{ dados }}</pre>
                                        <hr>
                                        <pre>{{ campos_atuais }}</pre>
                                    </div>
                                </div>
                            </div>
                        </template>                       
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-success" @click="atualizar()">Atualizar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { subscribe, unSubscribe } from "../../../service/Notify.js";
import AzLoading from '../../util/AzLoading.vue';
import AzInput from '../../shared/forms/AzInput.vue';

import $ from 'jquery';
import _ from 'lodash';

export default {
    data() {
        return {
            canal: "", 
            retorno: "", 
            dados: null, 
            acao: "GF", 
            ident: "", 
        }
    },

    props: ['atendimento', 'show'],

    components: { 
        AzLoading,
        AzInput, 
    },

    beforeDestroy() {
        this.finalizar();
    },

    computed: { 
        is_teste: function () { 
            return this.dominio == 'teste'
                || this.dominio == 'homologacao'
                || this.dominio == 'comercial'
                || this.dominio == 'treinamento'
                || this.dominio == 'softfy'
                || this.dominio == 'fantini'
                || this.dominio == 'support';
        },

        dominio: function () { 
            return window.redir;
        },

        campos_atuais: function () { 
            return this.atendimento.atendimento_procedimentos[0].anamnese.dados.filter(campo => campo.id && ( campo.type == 'textarea' || campo.type == 'text' )) 
                .map(campo => { 
                    return { 
                        id: campo.id, 
                        label: campo.label ? campo.label : campo.id,
                        type: campo.type, 
                    };
                })
                .sort();
        },

        profissional: function () { 
            return this.dominio + ':' + this.$store.state.user.id_usuario;
        },
    },

    methods: {
        reabrir () { 
            $('#daaiModal').modal('show');
        },

        copiar_texto (texto, title) { 
            this.$util.copiar_clipboard(this, texto, "Texto de '" + title + "' copiado com sucesso.");
        },

        iniciar() { 

            if ( !this.canal ) { 

                this.canal = this.$util.uuidv4();
                this.retorno = ""; 

                this.$nextTick(() => { 
                    console.log('refs-daai', this.$refs);

                    this.$refs.daai.onSuccess = this.onSuccess;
                    this.$refs.daai.onError = this.onError;
                });

                console.log('canal', this.canal);

                subscribe(this.$store.state.dominio, this.canal, (retorno) => {

                    this.reabrir();

                    console.log('subscribe retorno 1', retorno);

                    setTimeout(() => { 

                        this.retorno = retorno;
                        
                        this.$util.loadItem(this, { 
                            service: 'pep', 
                            func: 'daai_dados', 
                            parms: { 
                                id: this.atendimento.id_atendimento, 
                                cn: this.canal, 
                                chave: this.retorno.data.chave,
                            }
                        })
                        .then(res => { 
                            console.log('subscribe retorno 2', res);
    
                            this.dados = res.retorno;
    
                            console.log('dados', this.dados);
                        });
                        
                    }, 1000);

                });

            } else { 

                this.finalizar();

            }
        },

        finalizar () { 
            if ( this.canal ) { 
                unSubscribe(this.$store.state.dominio, this.canal);
                this.canal = "";
            }
        },

        atualizar () { 
            let formulario;
            let valores;
            let base;

            switch (this.acao) {
                case 'GF':
                    formulario = _.map(this.dados.campos, dado => {
                        return {
                            type: 'textarea', 
                            label: dado.title,
                            width: '6',
                            value: dado.value,
                            id: dado.id,
                        };
                    });

                    formulario.push({
                        type: 'textarea', 
                        label: 'Anotações',
                        width: '6',
                        value: "",
                        id: 'notas',
                    });

                    this.atendimento.atendimento_procedimentos[0].anamnese.dados = formulario;
                    break;

                case 'CT':
                    this.$util.copiar_clipboard(this, this.dados.transcricao, "Transcrição copiada com sucesso.");
                    break; 

                case 'CR':
                    this.$util.copiar_clipboard(this, this.dados.resumo, "Texto copiado com sucesso.");
                    break; 

                case 'PF':
                    valores = {};
                    
                    _.forEach(this.dados.campos, dado => {
                        if (dado.id) {
                            valores[dado.kid ? dado.kid : '?'] = dado.value;
                        }
                    });

                    // valores = this.$utilform.obter_campos(campos);

                    console.log('valores', valores);

                    base = this.atendimento.atendimento_procedimentos[0].anamnese.dados;
                      this.$utilform.preencher_campos(base, valores);

                    break;
            
                default:
                    break;
            }

            $('#daaiModal').modal('hide');

            this.finalizar();
        },

        onSuccess(data) {
            console.log('onSuccess', data);
            this.$toast.add({
                severity: 'success',
                detail: 'Requisição processada com sucesso',
                life: 3000
            });

            this.dados = null;

            $('#daaiModal').modal('show');
        },
        onError(data) {
            console.log('onError', data);
            this.$toast.add({
                severity: 'error',
                summary: "Erro",
                detail: 'Erro ao processar a requisição',
                life: 3000
            });
        }
    },

    mounted() {
        this.ident = this.$util.uuidv4();
        //this.$refs.daai.onSuccess = this.onSuccess;
        //this.$refs.daai.onError = this.onError;
    }
}
</script>

<style scoped>
.chat_container {
    z-index: 9999999;
}
</style>